import {DropdownOptionProps} from '../../../models/DropdownProps';
import {SELECT_TYPE} from '../../../utils/DropdownOptionPropsUtils';

export const sheetFileTypeResource: DropdownOptionProps[] = [
    {
        name: SELECT_TYPE, value: SELECT_TYPE
    },
    {
        name: 'csv', value: 'csv'
    },
    {
        name: 'ods', value: 'ods'
    },
    {
        name: 'vnd.oasis.opendocument.spreadsheet', value: 'vnd.oasis.opendocument.spreadsheet'
    },
    {
        name: 'xls', value: 'xls'
    },
    {
        name: 'vnd.ms-excel', value: 'vnd.ms-excel'
    },
    {
        name: 'xlsx', value: 'xlsx'
    },
    {
        name: 'vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        value: 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
];